// @flow

import compare, { type SortDirection, type SortType } from './compare';

export type {
  SortDirection,
  SortType,
};

export default compare;
